<template>
  <div>
    <div class="b-card">
      <div class="b-card-title">Brunnar</div>
      <div class="form-group">
        <label for="wellCount">Antal brunnar</label>
        <input
          id="wellCount"
          v-model.number="count"
          type="number"
          min="0"
          :max="maxWells"
          @input="clamp"
          @change="commit"
        />
        <p class="field-hint">Max {{ maxWells }} brunnar. Varje brunn fylls i separat nedan.</p>
      </div>
    </div>

    <div
      v-for="(form, n) in forms"
      :key="n"
      :class="['well-block', { collapsed: collapsedStates[n] }]"
    >
      <h2 class="collapsible-heading" @click="store.toggleCollapsed(n)">
        <span class="well-heading-main">
          <span class="well-heading-title">Brunn {{ n + 1 }}</span>
          <span v-if="collapsedStates[n]" class="well-collapsed-summary">
            {{ collapsedSummary(form) }}
          </span>
        </span>
        <span class="collapse-toggle">
          <font-awesome-icon :icon="collapsedStates[n] ? 'chevron-down' : 'chevron-up'" />
          {{ collapsedStates[n] ? 'Visa' : 'Göm' }}
        </span>
      </h2>

      <OrderForm v-show="!collapsedStates[n]" :index="n" />

      <div v-if="!collapsedStates[n]" class="well-actions">
        <div class="well-actions-inner">
          <button type="button" class="delete-btn" @click="store.removeWell(n)">
            Ta bort brunn {{ n + 1 }}
          </button>
        </div>
      </div>
    </div>

    <p v-if="!forms.length" class="b-choices-empty">
      Ange antal brunnar ovan för att börja fylla i brunnsdata.
    </p>
  </div>
</template>

<script>
import OrderForm from './OrderForm.vue'
import { store, MAX_WELLS } from '@/store.js'

export default {
  name: 'StepWells',
  components: { OrderForm },
  data() {
    return { store, count: store.wellCount, maxWells: MAX_WELLS }
  },
  computed: {
    forms() {
      return this.store.forms
    },
    collapsedStates() {
      return this.store.collapsedStates
    },
  },
  watch: {
    // Håll fältet i synk när antalet ändras utifrån (t.ex. "Ta bort brunn").
    'store.wellCount'(value) {
      this.count = value
    },
  },
  methods: {
    clamp() {
      if (this.count === '' || this.count === null || this.count < 0) this.count = 0
      if (this.count > MAX_WELLS) this.count = MAX_WELLS
    },
    commit() {
      this.clamp()
      this.store.setWellCount(this.count)
    },
    collapsedSummary(form) {
      const parts = []
      parts.push(form.littera ? `Littera ${form.littera}` : 'Littera saknas')
      if (form.dimension) parts.push(`Ø ${form.dimension}`)
      const inlets = (form.items || []).length - 1
      parts.push(inlets > 0 ? `${inlets} inlopp` : 'inga inlopp')
      return parts.join(' · ')
    },
  },
}
</script>
